import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertType } from '../../models';

@Component({
  selector: 'app-alert-undo',
  templateUrl: './alert-undo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertUndoComponent {
  @Input()
  alertType: AlertType;

  @Input()
  text: string;

  @Input()
  onUndo: () => unknown;

  @Output()
  closeClick = new EventEmitter<void>();

  onUndoClick(): void {
    this.onUndo();
  }

  buildTranslationKey(relativeKey: string): string {
    return `core.globalAlerts.undo.${relativeKey}`;
  }
}
